import FeatureGates, {
  FeatureGateEnvironment,
} from "@atlaskit/feature-gate-js-client";
import Environment from "../common/environment";
import storage from "../utils/storage";

const getEnvironment = () => {
  switch (Environment.getEnvironment()) {
    case Environment.production():
      return {
        apiKey: "b9a5d4ea-66db-4082-8e75-963afd1dd6ba",
        environment: FeatureGateEnvironment.Production,
      };
    case Environment.staging():
      return {
        apiKey: "b5aed4e1-3366-49e8-9089-c9da89200d7b",
        environment: FeatureGateEnvironment.Staging,
      };
    case Environment.dev():
    default:
      return {
        apiKey: "9a4301e9-b660-44be-998f-257208d5cffb",
        environment: FeatureGateEnvironment.Development,
      };
  }
};

const atlassianAccountId = () => {
  const aaId = (storage.getCookie("__aid_user_id") ?? "").replace(/\"/g, "");
  return aaId || undefined;
};

const anonymousId = () => {
  const cleanAnonymousId = decodeURIComponent(storage.getCookie("ajs_anonymous_id") ?? "").replace(/['"]+/g, "");
  return cleanAnonymousId || undefined;
};


const tenantId =
  new URLSearchParams(window?.location?.search).get("cloudId") ?? undefined;

// TODO: Add more custom attributes as needed
const customAttributes = () => {
  const cloudSessionToken =
    storage.getCookie("cloud.session.token") ||
    storage.getCookie("cloud.session.token.stg");

  return {
    loginUserDetected: cloudSessionToken !== undefined,
  };
};

/**
 * Initialize FeatureGates client
 * Doc: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/measurement/feature-gate-js-client
 */
export const initializeFeatureGates = async (): Promise<void> => {
  try {
    console.info("Initializing FeatureGates client");
    await FeatureGates.initialize(
      {
        apiKey: getEnvironment().apiKey,
        environment: getEnvironment().environment,
        targetApp: "bxp-magnolia_web",
        eventLoggingApi: "https://xp.atlassian.com/v1/",
      },
      {
        analyticsAnonymousId: anonymousId(),
        atlassianAccountId: atlassianAccountId(),
        tenantId,
      },
      customAttributes()
    );
  } catch (err) {
    console.error("Failed to initialize FeatureGates client.", err);
  }
};

